import { Observable } from 'rxjs';
import { ApiService, CREATE_CONTACT_MESSAGE_PATH, CreateContactMessageBody } from '@core-http';

export class ContactService extends ApiService {
  sendMessage(requestBody: CreateContactMessageBody): Observable<void> {
    return this.httpClient.post<void>(`${this.env.apiUrl}${CREATE_CONTACT_MESSAGE_PATH}`, requestBody);
  }
}
